/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_Applications_Hidden_SubtitleInputs */

const en_job_detail_applications_hidden_subtitle = /** @type {(inputs: Job_Detail_Applications_Hidden_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidates can already apply for this position. Submitted applications will appear here once you have added interview time slots – grouped by status.`)
};

const de_job_detail_applications_hidden_subtitle = /** @type {(inputs: Job_Detail_Applications_Hidden_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerber können sich bereits jetzt auf diese Stelle bewerben. Eingegangene Bewerbungen erscheinen hier, sobald Sie Termine für Bewerbungsgespräche angelegt haben – gruppiert nach Status.`)
};

/**
* | output |
* | --- |
* | "Candidates can already apply for this position. Submitted applications will appear here once you have added interview time slots – grouped by status." |
*
* @param {Job_Detail_Applications_Hidden_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_applications_hidden_subtitle = /** @type {((inputs?: Job_Detail_Applications_Hidden_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_Applications_Hidden_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_applications_hidden_subtitle(inputs)
	return en_job_detail_applications_hidden_subtitle(inputs)
});